

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { RootState } from '@/store/types';
import {
  Firmware,
  ParsedFirmware,
  FirmwareState,
} from '../store/firmware/types';
import Alert from '@/components/Alert.vue';

const namespace: string = 'firmware';

@Component({
  components: {
    Alert,
  },
})
export default class FirmwaresForm extends Vue {
  @State('firmware') private firmwareState: FirmwareState;
  @Action('getFirmwares', { namespace }) private getFirmwares: () => Firmware;
  @Action('uploadFirmware', { namespace }) private uploadFirmware: (
    ...[]
  ) => void;
  @Getter('parsedFirmwares', { namespace })
  private parsedFirmwares: ParsedFirmware[];

  private columns: string[] = ['type', 'version', 'md5'];

  public mounted() {
    this.getFirmwares();
  }

  public onUploadFirmware(type: string) {
    const file = this.$refs[`file${type}`];
    this.uploadFirmware({ file, type });
  }
}
